var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-languages"},[_c('div',{staticClass:"cadre"},[_c('page-corners')],1),_c('div',[_c('h2',[_vm._v("Les royaumes de")]),_c('h1',[_vm._v("Madagascar")]),_c('Languages')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }